module.exports = __webpack_public_path__ + "static/media/applyProject1.96855abe.jpg";